<template>
    <div id="download-premiere-extension">
        <div id="app-layout-right-column__content__title">
            <span>Download Premiere Pro Extension</span>
        </div>

        <div class="py-3">
            <p class="pr-1">Effortlessly upload your timeline to fylm.ai and sync your color grades directly in Premiere Pro.</p>
            <p class="pr-1">Experience real-time collaboration and unlock a truly seamless remote grading workflow where creativity
               knows no boundaries.</p>

            <div class="buttons-container mt-8 d-flex justify-center">
                <button type="button"
                        class="button button--primary"
                        @click="onDownload"
                        :disabled="downloading || isCurrentPlanFree"
                >
                    <v-progress-circular v-if="downloading" indeterminate color="var(--color-white)" size="18"
                                         width="3"
                    ></v-progress-circular>
                    <span v-else class="font-weight-bold">Download</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import download from 'downloadjs';
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            downloading: false,
        };
    },

    computed: {
        ...mapGetters("User", ["isCurrentPlanFree"]),
    },

    methods: {
        ...mapActions('Downloadables', ['fetch']),

        async onDownload() {
            if (this.isCurrentPlanFree) return;

            this.downloading = true;

            try {
                const res = await this.fetch();

                await fetch(res.data.files.zip.presignedUrl)
                    .then(response => response.blob())
                    .then(blob => {
                        download(blob, res.data.files.zip.name);
                    })
                    .catch(error => console.error('Download failed:', error));
            } catch (e) {
                //
            } finally {
                this.downloading = false;
            }

        },
    },
};
</script>

<style lang="scss">
#download-premiere-extension {
    p {
        line-height: 1.25;
    }
}
</style>